module.exports = __webpack_public_path__ + "img/tishi.80855b1a.png";